/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./beacon.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./beacon.component";
var styles_UILensBeaconComponent = [i0.styles];
var RenderType_UILensBeaconComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_UILensBeaconComponent, data: {} });
export { RenderType_UILensBeaconComponent as RenderType_UILensBeaconComponent };
export function View_UILensBeaconComponent_0(_l) { return i1.ɵvid(0, [], null, null); }
export function View_UILensBeaconComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "ui-lens-beacon", [], null, null, null, View_UILensBeaconComponent_0, RenderType_UILensBeaconComponent)), i1.ɵdid(1, 49152, null, 0, i2.UILensBeaconComponent, [], null, null)], null, null); }
var UILensBeaconComponentNgFactory = i1.ɵccf("ui-lens-beacon", i2.UILensBeaconComponent, View_UILensBeaconComponent_Host_0, {}, {}, []);
export { UILensBeaconComponentNgFactory as UILensBeaconComponentNgFactory };
